export default "__VITE_ASSET__BbOe16_I__"